/* istanbul ignore file */
import { useParams } from 'react-router-dom';
import AccountPageLayout from './AccountPageLayout';
import { RelatedOpportunitiesList } from 'domain/sales/opportunity';
import AccountRelatedOpportunitiesBreadcrumbs from 'domain/sales/account/Show/AccountRelatedOpportunitiesBreadcrumbs';
import useOpportunityService from 'domain/sales/opportunity/opportunityService';

const AccountRelatedOpportunities = () => {
  const { search } = useOpportunityService();
  const { id } = useParams<{ id: string }>();

  const getDataMethod = async (params: any) => {
    return search({
      filter: {
        'account.alias': { eq: id },
      },
      ...params,
    });
  };

  return (
    <AccountPageLayout breadcrumbs={<AccountRelatedOpportunitiesBreadcrumbs />}>
      <RelatedOpportunitiesList getDataMethod={getDataMethod as any} isActionsVisible />
    </AccountPageLayout>
  );
};

export default AccountRelatedOpportunities;
